import { useBreakpoint } from '@landr/maestro';
import React, { useContext } from 'react';
import { Pack, Repack } from 'types/generated/graphql';

export interface CarouselContextProps {
    carouselName: Pack['name'] | Repack['name'];
    carouselGuid: Pack['guid'] | Repack['guid'];
    children: React.ReactNode;
    withPreview?: boolean;
}

export type CarouselContextType = {
    carouselName: string;
    carouselGuid: string;
    isPreviewAllowed: boolean;
};

const defaultCarouselContext = {
    carouselName: '',
    carouselGuid: '',
    isPreviewAllowed: true,
};

const CarouselContext = React.createContext<CarouselContextType>(
    defaultCarouselContext,
);

export const useCarouselContext = (): CarouselContextType =>
    useContext(CarouselContext);

export const CarouselProvider: React.FC<CarouselContextProps> = ({
    carouselName = '',
    carouselGuid,
    withPreview = true,
    children,
}): JSX.Element => {
    const isMobile = useBreakpoint('md');

    const isPreviewAllowed = withPreview && !isMobile;

    return (
        <CarouselContext.Provider
            value={{
                carouselName,
                carouselGuid,
                isPreviewAllowed,
            }}
        >
            {children}
        </CarouselContext.Provider>
    );
};

export default CarouselContext;
